import JSONRPC from './JSONRPC';
import type { JsonRpcTransport } from './types/JSONRPCAPI';
import type {
  PosAppPermissionsQtObject,
  PosAppPermissionsRestartResponse,
  PosAppPermissionsState,
} from './types/PosAppPermissions';

export type {
  PosAppPermissionsQtObject,
  PosAppPermissionsRestartResponse,
  PosAppPermissionsState,
} from './types/PosAppPermissions';

function createNullJsonRpc(): JsonRpcTransport {
  return {
    request: <T = unknown>() => Promise.resolve(null as T),
    handleResponse: () => undefined,
  };
}

export class PosAppPermissionsApi {
  private jsonrpc: JsonRpcTransport;

  // dummy dispatcher that resolves all calls to null
  constructor() {
    // dummy dispatcher that resolves all calls to null
    this.jsonrpc = createNullJsonRpc();
  }

  connect(qtobject: PosAppPermissionsQtObject | null): void {
    // connecting all state actions here
    try {
      if (qtobject) {
        this.jsonrpc = new JSONRPC((message) =>
          qtobject.dispatch(JSON.stringify(message))
        );
        qtobject.response.connect((str: string) =>
          this.jsonrpc.handleResponse(JSON.parse(str))
        );
      }
    } catch (e) {
      console.log(e);
      this.jsonrpc = createNullJsonRpc();
    }
  }

  getState(): Promise<PosAppPermissionsState> {
    return this.jsonrpc.request<PosAppPermissionsState>('get_state');
  }

  reStartAsAdmin(): Promise<PosAppPermissionsRestartResponse> {
    return this.jsonrpc.request<PosAppPermissionsRestartResponse>(
      're_start_as_admin'
    );
  }
}
const api = new PosAppPermissionsApi();

export { api as default };
